import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, ComponentRef, ViewContainerRef } from '@angular/core';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { CellType, FlexGrid } from '@grapecity/wijmo.grid';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0902Model } from './kymw0902.model';
import { DutiesDivPlanGoodsListModel } from './vo/duties-div-plan-goods-list.model';
import { KYMW0300InputModel } from '../../kymw03/kymw0300/vo/kymw0300-input.model';
import { KYMW0300OutputModel } from '../../kymw03/kymw0300/vo/kymw0300-output.model';
import { KYMW0D00InputModel } from '../../kymw0d/kymw0d00/vo/kymw0d00-input.model';
import { KYMW0300Component } from '../../kymw03/kymw0300/kymw0300.component';
import { KYMW0D00Component } from '../../kymw0d/kymw0d00/kymw0d00.component';
import { OrderCodeTextInputComponent } from '../../kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { CodeComboBoxComponent } from '../../kymw02/combo-box/code-combo-box/code-combo-box.component';
import { DataGridUtil } from './../../../commons/kymw00/data-grid-util';
import { UpdateDutiesDivPlanGoodsListService } from './api-services/kymw09-update-duties-div-plan-goods-list.service';
import { GetDutiesDivPlanGoodsListService } from './api-services/kymw09-get-duties-div-plan-goods-list.service';
import { KYMW0300Model } from '../../kymw03/kymw0300/kymw0300.model';


/**
 * 業態別企画設定画面を管理するクラス
 *
 * @export KYMW0902Component
 * @class KYMW0902Component
 */
@Component({
  selector: 'app-kymw0902',
  templateUrl: 'kymw0902.component.html',
  styleUrls: ['kymw0902.component.scss'],
  providers: [
    GetDutiesDivPlanGoodsListService,
    UpdateDutiesDivPlanGoodsListService
  ],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0902Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('cmb_DutiesFormDailyDiv', { static: true }) cmb_DutiesFormDailyDiv: CodeComboBoxComponent;
  @ViewChild('btn_searchGoods', { static: true }) btn_searchGoods: ElementRef;
  @ViewChild('dtg_PlanGoodsList', { static: true }) dtg_PlanGoodsList: FlexGrid;
  @ViewChild('btn_AllSelect', { static: true }) btn_AllSelect: ElementRef;
  @ViewChild('btn_AllUnSelect', { static: true }) btn_AllUnSelect: ElementRef;
  @ViewChild('btn_Cancel', { static: true }) btn_Cancel: ElementRef;
  @ViewChild('btn_Update', { static: true }) btn_Update: ElementRef;
  @ViewChild('btn_Reflection', { static: true }) btn_Reflection: ElementRef;

  // 親画面からの連携値
  param: any;

  kymw0902Model: KYMW0902Model = new KYMW0902Model();

  private kymw0300InputVO: KYMW0300InputModel = null;                           // 商品検索画面のVO

  public kymw0300Component: KYMW0300Component;

  public kymw0300Model: KYMW0300Model = new KYMW0300Model();

  /**
   * DataGridの列名とテーブル物理名を紐付ける連想配列Object
   */
  private tableName: Array<any>;

  private DutiesDivPlanGoodsVOList: DutiesDivPlanGoodsListModel;

  /**
   * Creates an instance of KYMW0902Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0902Component
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
    private getDutiesDivPlanGoodsListService: GetDutiesDivPlanGoodsListService,
    private updateDutiesDivPlanGoodsListService: UpdateDutiesDivPlanGoodsListService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    public viewContainerRef: ViewContainerRef,
  ) {
    super(kymw00Model);

    this.tableName = [];
    this.tableName['ClassCodeName'] = 'CLASS_CODE';
    this.tableName['SmallClassCodeName'] = 'SMALL_CLASS_CODE';
    this.tableName['GuideGoodsName'] = 'GUIDE_GOODS_NAME';
    this.tableName['GuideStandardName'] = 'GUIDE_STANDARD_NAME';
    this.tableName['Pcode'] = 'PCODE';
    this.tableName['DutiesFormDailyDivName'] = 'DUTIES_FORM_DAILY_DIV';
    this.tableName['HandlingCoop1'] = 'handlingCoop1';
    this.tableName['HandlingCoop2'] = 'handlingCoop2';
    this.tableName['HandlingCoop3'] = 'handlingCoop3';
    this.tableName['HandlingCoop4'] = 'handlingCoop4';
    this.tableName['HandlingCoop5'] = 'handlingCoop5';
    this.tableName['HandlingCoop6'] = 'handlingCoop6';
    this.tableName['HandlingCoop7'] = 'handlingCoop7';
    this.tableName['HandlingCoop8'] = 'handlingCoop8';
    this.tableName['HandlingCoop9'] = 'handlingCoop9';
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0902Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW0902';
    this.kymw0902Model.kymw0902Component = this;

    setTimeout(() => {
      this.plessEnabledSetting();
    });

    this.dtg_PlanGoodsList.itemsSourceChanged.addHandler(() => {
      this.dtg_PlanGoodsList.select(-1, -1);
    });

    this.dtg_PlanGoodsList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_PlanGoodsList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_plan_goods_${ht.row}`).click();
      }
    });
  }

  public plessEnabledSetting() {
    this.plessEnabled(this.btn_searchGoods, false);
    this.plessEnabled(this.btn_Cancel, false);
    this.plessEnabled(this.btn_Update, false);
    this.plessEnabled(this.btn_Reflection, false);
    this.plessEnabled(this.btn_AllUnSelect, false);
    this.plessEnabled(this.btn_AllSelect, false);
    this.kymw0902Model.activeBtnBack = false;
    this.kymw0902Model.activeBtnNext = false;
  }

  /**
   * 「受注コード」変更イベント処理
   */
  public eventOrderCodeChangedHandler(): void {

    if (!PlessViewUtilsSub.isEmpty(this.txti_OrderCode.selectedCatalogID)) { // ０より大きい場合(有効企画回)
      this.plessEnabled(this.btn_searchGoods, true);					// 商品検索ボタン活性化
    } else { // ０の場合(無効企画回)
      // 商品検索ボタンを非活性にする
      this.plessEnabled(this.btn_searchGoods, false);					// 商品検索ボタン
    }
    this.clearList();
  }

  /**
   * 「商品検索」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventSearchGoods_CLICKHandler(): void {
    if (this.kymw0902Model.isEdited) {
      // 編集内容破棄の確認Msgダイアログ表示
      this.dialogServiceSub.openAlertGetMessage('Q0107', ['業態別企画商品情報'],
        (closeDetail) => {
          this.searchEventAlert_CLICKHandler(closeDetail);
        });
    } else {
      // 「商品検索ポップアップ用インプットVO」の生成
      // ２回目以降の表示は前回の情報を引き継ぐ
      if (this.kymw0300InputVO == null) {
        this.kymw0300InputVO = new KYMW0300InputModel();
      }
      // 企画関連条件を表示しない（企画検索フラグ:0）
      this.kymw0300InputVO.catalogSearchFlg = 0;

      // 商品検索画面(モーダル)を表示する。
      const kymw0300ComponentRef = this.dialogServiceSub.openModal(KYMW0300Component);
      const kymw0300Instance = kymw0300ComponentRef.componentInstance as KYMW0300Component;
      kymw0300Instance.parent = this;
      if (kymw0300ComponentRef != null) {
        this.kymw0300Component = kymw0300ComponentRef.componentInstance as KYMW0300Component;
        this.kymw0300Component.parent = this;
        this.kymw0300Component.setInterfaceParam(this.kymw0300InputVO);
        this.kymw0300Component.setKYMW0300Parameter =
          (outputVO: KYMW0300OutputModel) => this.setKYMW0300Parameter(outputVO);
      }
      // ウィンドウが閉じられる際の処理
      kymw0300Instance.closeFunction = () => {
        kymw0300ComponentRef.close();
      };
    }
  }

  /**
   * 商品検索処理確認メッセージイベントリスナ
   */
  public searchEventAlert_CLICKHandler(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      // 「商品検索ポップアップ用インプットVO」の生成
      // ２回目以降の表示は前回の情報を引き継ぐ
      if (this.kymw0300InputVO == null) {
        this.kymw0300InputVO = new KYMW0300InputModel();
      }
      // 企画関連条件を表示しない
      this.kymw0300InputVO.catalogSearchFlg = 0;

      // 商品検索画面(モーダル)を表示する。
      const kymw0300ComponentRef = this.dialogServiceSub.openModal(KYMW0300Component);
      const kymw0300Instance = kymw0300ComponentRef.componentInstance as KYMW0300Component;
      kymw0300Instance.parent = this;
      if (kymw0300ComponentRef != null) {
        this.kymw0300Component = kymw0300ComponentRef.componentInstance as KYMW0300Component;
        this.kymw0300Component.parent = this;
        this.kymw0300Component.setInterfaceParam(this.kymw0300InputVO);
        this.kymw0300Component.setKYMW0300Parameter =
          (outputVO: KYMW0300OutputModel) => this.setKYMW0300Parameter(outputVO);
      }
      // ウィンドウが閉じられる際の処理
      kymw0300Instance.closeFunction = () => {
        kymw0300ComponentRef.close();
      };
    }
  }

  /**
   * 「デイリー指定」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventDivAppointname_CLICKHandler(event: Event): void {
    let checkFlg = Boolean(false);

    // 行選択チェック
    for (let i = Number(0); i < this.kymw0902Model.planGoodsList.length; i++) {
      const data: Object = this.kymw0902Model.planGoodsList[i];
      if (data['Selected']) {
        checkFlg = true;
        break;
      }
    }

    if (!checkFlg) {
      this.dialogServiceSub.openAlertGetMessage('E0105', ['業態別企画商品情報']);
      return;
    }

    // 00：掲載なしにする場合の確認処理
    if (this.kymw0902Model.dutiesFormDailyDiv === '00') {
      // 確認メッセージを表示
      this.dialogServiceSub.openAlertGetMessage('Q0150', ['デイリー'],
        (closeDetail) => this.divAppointnameEventAlert_CLICKHandler(closeDetail));
    } else {
      for (let i = Number(0); i < this.kymw0902Model.planGoodsList.length; i++) {
        const data: Object = this.kymw0902Model.planGoodsList[i];

        if (data['Selected']) {
          // 編集した行の「デイリー」を設定
          this.kymw0902Model.setStatusOrderNumList(i);
          this.dtg_PlanGoodsList.editableCollectionView.refresh(); // グリッドをリフレッシュ
        }
      }
    }
  }

  /**
   * デイリー指定確認メッセージイベントリスナ
   */
  public divAppointnameEventAlert_CLICKHandler(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      for (let i = Number(0); i < this.kymw0902Model.planGoodsList.length; i++) {
        const data: Object = this.kymw0902Model.planGoodsList[i];
        if (data['Selected']) {
          // 編集した行の「デイリー」を設定
          this.kymw0902Model.setStatusOrderNumList(i);
          this.dtg_PlanGoodsList.editableCollectionView.refresh();              // グリッドをリフレッシュ
        }
      }
    }
  }

  /**
   * 「全選択」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventAllCheck_CLICKHandler(event: Event): void {
    this.kymw0902Model.updatePageListAllSelected(true);
    this.dtg_PlanGoodsList.editableCollectionView.refresh();
  }

  /**
   * 「全解除」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventAllUnCheck_CLICKHandler(event: Event): void {
    this.kymw0902Model.updatePageListAllSelected(false);
    this.dtg_PlanGoodsList.editableCollectionView.refresh();
  }

  /**
   * 「前へ」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventBack_CLICKHandler(event: Event): void {
    this.pageClick(-1);
  }

  /**
   * 「次へ」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventNext_CLICKHandler(event: Event): void {
    this.pageClick(1);
  }

  /**
   *  ページャーボタン押下時　確認ダイアログ判定
   * 
   *  @param page 前へボタン：-1 次へボタン：1
   *  @event イベント 
   */
  public pageClick(page: number) {
    // 編集中の場合
    if (this.kymw0902Model.isEdited) {
      // 編集内容破棄の確認Msgダイアログ表示
      this.dialogServiceSub.openAlertGetMessage('Q0107', ['業態別企画商品情報'],
        (closeDetail: any) => {
          // 押下ボタンのチェック
          if (closeDetail === PlessAlert.Yes) {
            this.pageChange(page);
          }
        }
      );
    } else {
      this.pageChange(page);
    }
  }

  /**
   *  ページ変更
   * 
   *  @param page 前へボタン：-1 次へボタン：1
   *  @event イベント
   */
  public pageChange(page): void {
    // ページ番号の設定
    this.kymw0902Model.pageNum = this.kymw0902Model.pageNum + page;
    // 一覧クリア
    this.kymw0902Model.planGoodsList = [];
    // サーバにデータ取得を要求(Cairngormイベント発行)
    const vo = this.kymw0902Model.getDutiesDivPlanGoodsSearchConditionVO(this.kymw0300InputVO);
    this.getDutiesDivPlanGoodsListService.execute(this.kymw0902Model, vo);
  }

  /**
   * 「取消」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventClear_CLICKHandler(event: Event): void {
    if (this.kymw0902Model.isEdited) {
      // 編集内容破棄の確認Msgダイアログ表示
      this.dialogServiceSub.openAlertGetMessage('Q0107', ['業態別企画商品情報'],
        (closeDetail: any) => this.clearEventAlert_CLICKHandler(closeDetail));
    } else {
      // 一覧クリア
      this.clearList();

      // 業態別企画商品一覧最新化
      // サーバにデータ取得を要求(Cairngormイベント発行)
      const vo = this.kymw0902Model.getDutiesDivPlanGoodsSearchConditionVO(this.kymw0300InputVO);
      this.getDutiesDivPlanGoodsListService.execute(this.kymw0902Model, vo);
    }

  }

  /**
   * 取消処理確認メッセージイベントリスナ
   */
  public clearEventAlert_CLICKHandler(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      // 一覧クリア
      this.clearList();

      // 業態別企画商品一覧最新化
      // サーバにデータ取得を要求(Cairngormイベント発行)
      const vo = this.kymw0902Model.getDutiesDivPlanGoodsSearchConditionVO(this.kymw0300InputVO);
      this.getDutiesDivPlanGoodsListService.execute(this.kymw0902Model, vo);
    }
  }

  /**
   * 「更新」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventStatusUpdate_CLICKHandler(event: Event): void {
    // 編集フラグチェック
    if (!this.kymw0902Model.isEdited) {
      this.dialogServiceSub.openAlertGetMessage('E0111', ['業態別企画商品情報']);
      return;
    }
    // VO設定
    const vo: DutiesDivPlanGoodsListModel = new DutiesDivPlanGoodsListModel();

    // 受注コードの設定
    vo.OrderCode = this.kymw0902Model.orderCode;

    // 業態別企画商品一覧
    vo.DutiesDivPlanGoodsVOList = this.kymw0902Model.getChangedDutiesDivFormDailyVOList();

    // 更新対象データが存在しない場合はサーバへリクエストを行わない
    if (PlessViewUtilsSub.isEmptyArray(vo.DutiesDivPlanGoodsVOList)) {
      return;
    }

    // 確認メッセージのイベントリスナメソッドにVOを渡す為に、インスタンス変数にセットする
    this.DutiesDivPlanGoodsVOList = vo;
    // 確認メッセージを表示
    this.dialogServiceSub.openAlertGetMessage('Q0105', ['業態別企画商品情報'],
      (closeDetail: any) => this.updateEventAlert_CLICKHandler(closeDetail));
  }

  /**
   * 更新処理確認メッセージイベントリスナ
   */
  public updateEventAlert_CLICKHandler(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      // 業態別企画商品情報更新
      const vo = this.DutiesDivPlanGoodsVOList;

      this.updateDutiesDivPlanGoodsListService.execute(this.kymw0902Model, vo);
    }
  }

  /**
   * 終了ボタン押下イベント
   */
  public eventClose_CLICKHandler(event: Event): void {
    // 編集フラグのチェック
    if (this.kymw0902Model.isEdited) { // 編集中の場合
      // 編集内容破棄の確認Msgダイアログ表示
      this.dialogServiceSub.openAlertGetMessage('Q0107', ['業態別企画商品情報'],
        (closeDetail: any) => {
          // 押下ボタンのチェック
          if (closeDetail === PlessAlert.Yes) {                                  // はいボタンの場合
            // 終了処理
            this.onClickClose();
          }
        }
      );
    } else { 	// 未編集の場合
      // 終了処理
      this.onClickClose();
    }
  }

  /*--------------------------------------------------------------------------------------------------
    サブ画面「商品検索」戻りイベント
  ---------------------------------------------------------------------------------------------------*/
  /**
   * 商品検索サブ画面の結果設定
   * 商品検索サブ画面で設定した条件をもとに候補リストを表示
   */
  public setKYMW0300Parameter(outputVO: KYMW0300OutputModel): void {
    // 検索時はページ番号を1に初期化する
    this.kymw0902Model.pageNum = 1;

    // 検索条件を保持
    this.kymw0300InputVO = this.kymw0300Model.getKYMW0300SearchHistory(outputVO);

    //  商品検索画面を閉じる
    this.kymw0300Component.closeFunction();

    // サーバにデータ取得を要求(Cairngormイベント発行)
    const vo = this.kymw0902Model.getDutiesDivPlanGoodsSearchConditionVO(this.kymw0300InputVO);

    // 一覧クリア
    this.clearList();

    // 業態別企画商品情報取得API実行
    this.getDutiesDivPlanGoodsListService.execute(this.kymw0902Model, vo);
  }

  /**
   * 一覧クリア
   */
  public clearList(): void {
    // 一覧クリア
    this.kymw0902Model.pageNum = 1;                                             // 現在ページ
    this.kymw0902Model.totalNum = 0;                                            // 総件数
    this.kymw0902Model.startDispNum = 0;                                        // 開始件数
    this.kymw0902Model.endDispNum = 0;                                          // 終了件数
    this.kymw0902Model.planGoodsList = [];                             // 業態別企画商品一覧データ

    // 各ボタン活性・非活性制御
    this.kymw0902Model.activeBtnBack = false;                                    // 前へ
    this.kymw0902Model.activeBtnNext = false;                                    // 次へ
  }

  /**
   * 業態別企画商品一覧データグリッドヘッダクリックイベント処理
   */
  public eventDtgPlanGoodsList_HEADERRELEASEHandler(e: MouseEvent, grid: FlexGrid): void {
    // ヘッダー内部のがクリックされていない場合は何もしない
    if (grid.hitTest(e).cellType !== CellType.ColumnHeader || grid.hitTest(e).edgeLeft || grid.hitTest(e).edgeRight) {
      return;
    }

    // 編集フラグのチェック
    if (this.kymw0902Model.isEdited) {                                          // 編集中の場合
      // 編集内容破棄の確認Msgダイアログ表示
      this.dialogServiceSub.openAlertGetMessage('Q0107', ['業態別企画商品情報'],
        (closeDetail: any) => {
          // 押下ボタンのチェック
          if (closeDetail === PlessAlert.Yes) {                                  // はいボタンの場合
            // ソート処理
            this.eventDtgSort(e, grid);
          } else {
            return;
          }
        });
    } else { // 未編集の場合
      // ソート処理
      this.eventDtgSort(e, grid);
    }
  }

  /**
   * 業態別企画商品一覧ソート処理
   */
  private eventDtgSort(e: MouseEvent, grid: FlexGrid): void {
    // 後続のデフォルトイベントをキャンセル
    event.preventDefault();

    // データが0件の場合は何もしない
    if (!DataGridUtil.isSortable(e, grid)) {
      return;
    }

    // 選択カラムをクリックした場合も何もしない
    if (grid.hitTest(e).col === 0) {
      return;
    }

    // データグリッドのヘッダテキストを描画し、ASCとDESCをVOに設定
    this.kymw0902Model.orderKey = DataGridUtil.switchHeaderText(e, grid);
    // クリックされたデータグリッドの列から、DBの物理項目を取得
    this.kymw0902Model.sortKey = this.tableName[this.dtg_PlanGoodsList.columns[grid.hitTest(e).col].binding];
    // 取得できなかったら何もしない
    if (!this.kymw0902Model.sortKey) {
      return;
    }

    // ページカウンタの初期化
    this.kymw0902Model.pageNum = 1;

    // サーバにデータ取得を要求(Cairngormイベント発行)
    const vo = this.kymw0902Model.getDutiesDivPlanGoodsSearchConditionVO(this.kymw0300InputVO);
    this.getDutiesDivPlanGoodsListService.execute(this.kymw0902Model, vo);
  }

  /**
   * 業態別企画商品一覧最新化イベント処理
   */
  public reloadDutiesDivPlanGoodsList(): void {
    // 一覧クリア
    this.clearList();

    // 業態別企画商品一覧最新化
    // サーバにデータ取得を要求(Cairngormイベント発行)
    const vo = this.kymw0902Model.getDutiesDivPlanGoodsSearchConditionVO(this.kymw0300InputVO);
    this.getDutiesDivPlanGoodsListService.execute(this.kymw0902Model, vo);
  }

  /**
   * サーバ取得データを処理ログに表示する
   *
   * @param serverData サーバ取得データ
   */
  public updateResult(serverData: any): void {
    const inpVO: KYMW0D00InputModel = new KYMW0D00InputModel();
    // 画面ＩＤ
    inpVO.dispId = 'KYMW0902';
    // 正常件数
    inpVO.normalNum = (serverData.NormalNum) ? serverData.NormalNum : '';
    // 注意件数
    inpVO.attentionNum = (serverData.AttentionNum) ? serverData.AttentionNum : '';
    // 異常件数
    inpVO.abnormalNum = (serverData.AbnormalNum) ? serverData.AbnormalNum : '';
    // ＤＢ更新件数
    inpVO.updateNum = (serverData.UpdateNum) ? serverData.UpdateNum : '';
    // 処理件数
    inpVO.manageNum = (serverData.UpdateNum) ? serverData.ManageNum : '';

    // 処理ログの表示
    const componentRef = this.dialogServiceSub.openModal(KYMW0D00Component);
    const instance = componentRef.componentInstance as KYMW0D00Component;
    instance.parent = this;
    instance.setInterfaceParam(inpVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }
}
